module.exports = __webpack_public_path__ + "media/12.bc59690f.mp3";